import {defineMessages} from 'react-intl';

export default defineMessages({
	code: {
		id: 'supplierCode.code',
		defaultMessage: 'Code: {code}',
	}
});
